var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 64.001,
    cy: 63.999,
    fill: "#f24646",
    r: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.44 84.253 31.788-18.353a2.195 2.195 0 0 0 0-3.8l-31.788-18.355a2.2 2.2 0 0 0 -3.293 1.9v36.707a2.2 2.2 0 0 0 3.293 1.901z",
    fill: "#fffcee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.10da5306bdaf344abdf031abfc6ac297.svg";
export { ForwardRef as ReactComponent };